module.exports = {
          srcSet: __webpack_public_path__ + "5b1625a17e887738d0f528916d1d5d4b-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "5b1625a17e887738d0f528916d1d5d4b-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "5b1625a17e887738d0f528916d1d5d4b-120.png",
          toString:function(){return __webpack_public_path__ + "5b1625a17e887738d0f528916d1d5d4b-120.png"},
          
          width: 120,
          height: 120
        }